up.compiler(
  '[data-current-index]',
  (
    element,
    { itemSelector, containerSelector }: { itemSelector: string; containerSelector: string },
  ) => {
    function setIndexAndTotal() {
      const currentItem = document.querySelector(`${itemSelector}.-active`)
      if (currentItem) {
        const container = currentItem.closest(containerSelector)!
        const items = Array.from(container.querySelectorAll(itemSelector))
        const totalCount = items.length
        const currentIndex = items.indexOf(currentItem) + 1
        element.textContent = `${currentIndex} / ${totalCount}`
      }
    }

    setTimeout(setIndexAndTotal, 100) // Timeout to wait for .-active
  },
)
